import React from "react";
import { Link } from "react-router-dom";
import "./public-docs-footer.css";

function PublicDocsFooter() {
  return (
    <footer className="pdf-wrap">
      <div className="pdf-inner">
        <p className="pdf-copy">
          ©️ {new Date().getFullYear()} Gato Systems. All rights reserved
        </p>
        <div className="pdf-links">
          <Link to="/privacypolicy" className="pdf-link" target="_blank">
            Privacy Policy
          </Link>
          <Link to="/termsofuse" className="pdf-link" target="_blank">
            Terms of Use
          </Link>
        </div>
      </div>
    </footer>
  );
}

export default PublicDocsFooter;
